import {Component} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GraphServiceService } from '../../../../../services/graph-service.service';
import { CrmService } from '../../../../../services/api/crm.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from '../../../../../services/notify/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, EMPTY, from, Observable, Subscription, switchMap, take } from 'rxjs';
import { TFormState } from '../../../../../models/forms.model';
import { IMemberWithRole, MemberModel } from '../../../../../models/user.model';
import { AvatarSelectListComponent } from '../../../../../components/avatar-list-select/avatar-list-select.component';
import { IGraphNode } from '../../../../../modules/graph-konva/models/graph-kn.model-interfaces';
import { IStatusEdge } from '../../../../../models/graph.model';
type statusType = 'In'|'Out'
interface IBaseNodeStatus {
	label: string,
	description: string,
	is_successful: boolean,
	data: string,
	is_universal: boolean,
}
interface IAddNodeStatus extends IBaseNodeStatus { 
	target_ids: string,
	source_ids: string,
}
interface IEditNodeStatus extends IBaseNodeStatus { 
	to_archive: boolean,
}
@Component({
    selector: 'app-task-node-create-edit-form',
    templateUrl: './task-node-create-edit-form.html',
    styleUrl: './task-node-create-edit-form.scss'
})
export class AppTaskNodeCreateFormComponent {
    private subs = new Subscription()
	public formMode:'Edit'|'Create'|'View' = 'Create'
    public nodeData:IGraphNode|undefined = undefined
    public linkedStatuses:{in:IGraphNode[], out:IGraphNode[]} = {in:[],out:[]}
    public availableStatuses:{in:IGraphNode[], out:IGraphNode[]} = {in:[],out:[]}
    public linkedEdges:IStatusEdge[] = []
    public isUniversalInit:boolean|undefined = undefined
	public formState:TFormState = 'Default'
	public boardAlias:string = ''
	public createNodeForm: FormGroup|undefined = undefined
	public showSelectStatus:'Status_Out'|'Status_In'|'None' = 'None'
	public defaultColor:string = '#284073'
    public membersInTask:IMemberWithRole[]|undefined = undefined
    public allMembers:MemberModel[]|undefined = undefined
    public showDetailedMembers:boolean = false
	constructor(
		public graphService: GraphServiceService,
		public crmService: CrmService,
		public alertService: AlertService,
		public translateService: TranslateService,
		private fb: FormBuilder,
		private dialogRef:MatDialogRef<AppTaskNodeCreateFormComponent>,
        private dialog:MatDialog,
	) {}

	ngOnInit(): void {
		this.boardAlias = this.graphService?.optionBoard?.alias

		let data = this.nodeData
		this.createNodeForm = this.fb.group({
			label: [this.formMode === 'Create'? null : data?.bp_status_data?.label, {validators: [Validators.required]}],
			description: [this.formMode === 'Create'? null : data?.bp_status_data?.description]  ,
			is_successful: [this.formMode === 'Create'? false : data?.bp_status_data?.is_successful ],
			is_universal: [this.formMode === 'Create'? false : data?.bp_status_data?.is_universal ],
			is_archive: [{value:this.formMode === 'Create'? false : data?.bp_status_data?.is_archive,disabled:true}],
			to_archive: [this.formMode === 'Create'? false : data?.bp_status_data?.to_archive],
			is_finish: [this.formMode === 'Create'? false : data?.bp_status_data?.is_finish],
			is_initial: [this.formMode === 'Create'? false : data?.bp_status_data?.is_initial],
			colorCode: [this.formMode === 'Create'? this.defaultColor : (this.defaultColor||data?.bp_status_data?.data?.colorCode)],
			svg: [this.formMode === 'Create'? null : data?.bp_status_data?.data.svg?.class],
			target_ids: this.fb.array(this.linkedStatuses.out.map(r=>this.fb.control(r.id))),
			source_ids: this.fb.array(this.linkedStatuses.in.map(r=>this.fb.control(r.id))),
		})
		if (this.formMode === 'Edit') {
            this.isUniversalInit = this.nodeData?.bp_status_data?.is_universal
			this.statusIn.disable()
			this.statusOut.disable()
		}
		if (this.formMode === 'View') {
			this.svg?.disable()
		}
        this.setSubscriptions()
	}
    ngOnDestroy(): void {
        this.subs.unsubscribe()
    }
    setSubscriptions() {
        this.subs.add(this.graphService.subBoardEdges.asObservable().subscribe(edges=>this.linkedEdges=edges))
    }
    ngAfterContentInit(): void {
        if (['Edit','View'].includes(this.formMode)) {
            let userData = this.nodeData?.bp_status_data?.roles
            userData? this.membersInTask = [
                ...userData?.executor.map(el=>{return{
                    member:this.nodeData?.bp_status_data?.members?.find(mem=>mem.guid===el)!, role:'executor'}}),
                ...userData?.responsible.map(el=>{return{
                    member:this.nodeData?.bp_status_data?.members?.find(mem=>mem.guid===el)!, role:'responsible'}}),
                ...userData?.observer.map(el=>{return{
                    member:this.nodeData?.bp_status_data?.members?.find(mem=>mem.guid===el)!, role:'observer'}}),
            ] : null;
        }
    }
	prepareData():IAddNodeStatus|IEditNodeStatus {
		let data :IBaseNodeStatus = {
			label: this.label?.value,
			description: this.description?.value,
			is_successful: this.is_successful?.value,
			is_universal: this.is_universal?.value,
			data: JSON.stringify({
				colorCode: this.colorCode?.value,
				svg: {class:this.svg?.value},
			}),
		};
		let fullData = data as IAddNodeStatus|IEditNodeStatus;
		if (this.formMode === 'Create') {
			fullData = fullData as IAddNodeStatus;
			fullData.target_ids = this.is_universal?.value ? null : this.statusOut?.value.toString();
			fullData.source_ids = this.is_universal?.value ? null : this.statusIn?.value.toString();
		} else {
			fullData = fullData as IEditNodeStatus;
			fullData.to_archive = this.to_archive?.value ;
		}
		return fullData
	}

	createNewStatus() {
		this.formState = 'Submitting'
		let statusData:IAddNodeStatus = this.prepareData() as IAddNodeStatus 
		this.crmService.addNode(this.boardAlias, statusData)
		.pipe(
			switchMap(data=>from(this.graphService.selectBoard(data.board, true))),
			catchError(error=>this.errorHandler(error)))
		.subscribe(data=> {
			this.formState = 'Default';
			this.dialogRef.close()
			this.alertService.setAlert(this.translateService.instant('ALERTS.SUCCESS'), 'nd_color');
		})
	}

	updatStatus() {
        if (!this.nodeData?.id) {
            return
		}
        this.formState = 'Submitting'
		let statusData:IEditNodeStatus = this.prepareData() as IEditNodeStatus 
		this.crmService.updateNode(this.nodeData.id, statusData)
		.pipe(
			switchMap(data=>from(this.graphService.selectBoard(data.board, true))),
			catchError(error=>this.errorHandler(error)))
		.subscribe(() => {
			this.formState = 'Default';
			this.dialogRef.close();
			this.alertService.setAlert(this.translateService.instant('ALERTS.SUCCESS'), 'nd_color');
		})
	}

	addEmptyEdge(statusType:statusType) {
        let statuses = (statusType === 'In'? this.statusIn : this.statusOut) as FormArray
        statuses.push(this.fb.control('null'))
        if (this.formMode === 'Edit') {
            let index = statuses.controls.length -1 
            statuses.controls.at(index)?.valueChanges.pipe(take(1)).subscribe(() => statuses.controls[index].disable())
        }
	}

	addEdge(statusId:number,statusType:statusType) {
		if (!this.nodeData) {
			return
		}
		this.formState = 'Submitting'
		let edge = {
			source_id: statusType === 'In'? statusId.toString() : this.nodeData.id,
			target_id: statusType === 'Out'? statusId.toString(): this.nodeData.id 
		}
		this.crmService.addEdge(this.boardAlias, edge)    
		.pipe(
			switchMap(data=>from(this.graphService.selectBoard(data.board, true))),
			catchError(error=>this.errorHandler(error)))
		.subscribe(res => {
			this.formState = 'Default';
			this.alertService.setAlert(this.translateService.instant('ALERTS.SUCCESS'), 'nd_color');
		})
	}

	deleteEdge(statuses:FormArray, index:number,statusId:number,statusType:statusType) {
		let edgeIDNumber = statusType === 'In'?  
            this.linkedEdges.find(el=>el.source === statusId && el.target===Number(this.nodeData?.id))?.id :
            this.linkedEdges.find(el=>el.target === statusId&& el.source===Number(this.nodeData?.id))?.id
		statuses.removeAt(index)
        
		if (this.formMode === 'Edit' && edgeIDNumber) {
			this.formState = 'Submitting'
			this.crmService.deleteEdge(edgeIDNumber)
			.pipe(
				switchMap(data=>from(this.graphService.selectBoard(data.board, true))),
				catchError(error=>this.errorHandler(error)))
			.subscribe(() => {
				this.formState = 'Default';
				this.alertService.setAlert(this.translateService.instant('ALERTS.SUCCESS'), 'nd_color');
			})
		}
	}
    removeMemberFromStatus(data:IMemberWithRole) {
        if (!this.nodeData?.id) {
            return
        }
        let dataToDel = {
            status_id: this.nodeData.id,
            guid: data.member.guid,
            role: data.role
        };
        this.formState = 'Submitting'
        this.crmService.deleteMemberFromStatus(this.graphService.optionBoard.alias, dataToDel).subscribe({
            next: res => {
                this.membersInTask = this.membersInTask?.filter(el=>el.member.guid + el.role !== data.member.guid + data.role)
                this.formState = 'Default'
                this.alertService.setAlert(res.message, 'nd_color');
                this.graphService.selectBoard(this.graphService.optionBoard, true);
            }, error: err => {
                this.formState = 'Default'
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }
    openAddMemberToStatusForm(event:Event) {
        event.stopPropagation()
        let ref = this.dialog.open(AvatarSelectListComponent,{maxHeight:'80vh',maxWidth:'100%'})
        ref.componentInstance.formTitle = this.translateService.instant('MODALS.HEADERS.ADD_PARTY')
        ref.componentInstance.users = this.allMembers
        let emitter = ref.componentInstance.eventAddUser.subscribe(data=>this.addNewMemberToStatus(data,ref))
        ref.afterClosed().pipe(take(1)).subscribe(()=>emitter.unsubscribe())
    }
    addNewMemberToStatus(data: {user: MemberModel, role: string},formRef:MatDialogRef<AvatarSelectListComponent>) {
        if (!this.nodeData?.id) {
            return
        }
        let dataToSave = {
            status_id: this.nodeData.id,
            guid: data.user.guid,
            role: data.role
        };

        this.crmService.addMemberToStatus(this.boardAlias, dataToSave).subscribe({
            next: res => {
                formRef.componentInstance.addedUsers.push(data.user.guid)
                this.membersInTask?.push({member:data.user, role:data.role})
                formRef.componentInstance.formState = 'Default'
                this.alertService.setAlert(res.message, 'nd_color');
                this.graphService.selectBoard(this.graphService.optionBoard, true);
            }, error: err => {
                formRef.componentInstance.formState = 'Default'
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }
    isAddEdgeShown():boolean {
        if (this.formMode==='Edit') {
            return this.is_universal?.value !== true && this.is_archive?.value !== true && this.isUniversalInit === this.is_universal?.value
        } else {
            return this.is_universal?.value !== true && this.is_archive?.value !== true 
        }
    }
	isStatusUsed(statuses:FormArray, statusSelectId:string):boolean {
		return statuses.controls.map(el=>el.value).includes(statusSelectId)
	}
    isSuccessfulShown():boolean {
        if (this.formMode==='Edit') {
            return this.is_archive?.value !== true && this.is_universal?.value !==true && this.is_initial?.value !== true
        } else {
            return this.is_universal?.value !==true
        }
    }
    isUniversalShown():boolean {
        if (this.formMode==='Edit') {
            return this.is_archive?.value !== true && this.is_universal?.value === true && this.is_initial?.value !== true
        } else {
            return this.is_successful?.value !==true
        }
    }
    isToArchiveShown():boolean {
        if (this.formMode === 'Edit') {
            return this.is_initial?.value === false && this.is_archive?.value === false && this.is_finish?.value === true 
        } else {
            return false
        }
    }
	errorHandler(error:{message:string}):Observable<never> {
		this.formState = 'Default';
		this.alertService.setAlert(error.message, 'blue');
		return EMPTY
	}
	get label() {return this.createNodeForm?.get('label')}
	get description() {return this.createNodeForm?.get('description')}
	get is_successful()  {return this.createNodeForm?.get('is_successful')}
	get is_universal()  {return this.createNodeForm?.get('is_universal')}
	get to_archive()  {return this.createNodeForm?.get('to_archive')}
	get is_archive()  {return this.createNodeForm?.get('is_archive')}
	get is_finish()  {return this.createNodeForm?.get('is_finish')}
	get is_initial()  {return this.createNodeForm?.get('is_initial')}
	get colorCode()  {return this.createNodeForm?.get('colorCode')}
	get svg()  {return this.createNodeForm?.get('svg')}
	get statusIn()  {return this.createNodeForm?.get('source_ids') as FormArray}
	get statusOut()  {return this.createNodeForm?.get('target_ids') as FormArray}
}